/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockOpenIcon20Solid = forwardRef('SecurityLockOpenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 1A4.5 4.5 0 0 0 11 5.5V7H5a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3V5.5a2.5 2.5 0 0 1 5 0v.25a1 1 0 1 0 2 0V5.5A4.5 4.5 0 0 0 15.5 1ZM9.75 13.05a1.5 1.5 0 1 0-1.5 0v1.45a.75.75 0 0 0 1.5 0v-1.45Z" })));
});
